import React, { useEffect } from 'react'
import { getCriticalCareSelector } from '../../selectors'
import { useDispatch, useSelector } from 'react-redux'
import {
  saveCriticalCare,
  setAction,
  setSite,
  setTask,
  setTransducerZeroedPre,
  setTransducerZeroedPost,
  setTriggerUtilizedPre,
  setTriggerUtilizedPost,
  setIabpFrequencyPre,
  setIabpFrequencyPost,
  setIabpAugmentationPre,
  setIabpAugmentationPost,
  setSlowGasLeakAlarmPre,
  setSlowGasLeakAlarmPost,
  setTimingPre,
  setTimingPost,
  setIabpFillPre,
  setIabpFillPost,
  setAugmentationAlarmSetPre,
  setAugmentationAlarmSetPost,
  setLeftBrachialPulsePre,
  setLeftBrachialPulsePost,
  setDistalPulsePresentInAffectedExtremityPre,
  setDistalPulsePresentInAffectedExtremityPost,
  setInsertionSitePre,
  setInsertionSitePost,
  setExtremityRestrainedPre,
  setExtremityRestrainedPost,
  setInflationPointPre,
  setInflationPointPost,
  setDeflationPointPre,
  setDeflationPointPost,
  setDiastolicAugmentationPre,
  setDiastolicAugmentationPost,
  setUnaugmentedDiastolePre,
  setUnaugmentedDiastolePost,
  setDiastolicDipPre,
  setDiastolicDipPost,
  setAugmentedSystolePre,
  setAugmentedSystolePost,
  setUnaugmentedSystolePre,
  setUnaugmentedSystolePost,
  setDefaultValuesForIABP,
} from '../../store/criticalCare.actions'
import { IonCol, IonGrid, IonItemDivider, IonLabel, IonList, IonRow } from '@ionic/react'
import { IOption } from '../../../../../common/common.types'
import { useTranslation } from 'react-i18next'
import { IPHIComponent } from '../../../../../components/phi/phi.component'
import SingleSelect from '../../../../../components/singleSelect/SingleSelect.component'
import './criticalCare.content.css'
import SInput from '../../../../../components/stringInput/StringInput.component'
import { getCriticalCareOptionsSelector } from '../../../../options/selectors/criticalCareOptions.selector'
import { ICriticalCareOptionsState } from '../../../../options/store/options.types'
import { getCcHpiOptionsSelector } from '../../../../options/selectors'
import _ from 'lodash'
import { CriticalCareConstants } from '../../store/criticalCare.constants'
import { getProcedureStateSelector } from '../../../../../components/procedure/selectors'

const CriticalCareContent: React.FC<IPHIComponent> = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const ccHpiOptions = useSelector(getCcHpiOptionsSelector)
  const { therapeuticHypothermiaOptions } = ccHpiOptions

  const criticalCareOptions = useSelector(getCriticalCareOptionsSelector)
  const {
    actionOptions,
    siteOptions,
    taskOptions,
    iabpAugmentationOptions,
    iabpFrequencyOptions,
    insertionSiteOptions,
    slowGasLeakOptions,
    triggerUtilizedOptions,
    autoManualOptions,
  }: ICriticalCareOptionsState = criticalCareOptions

  const criticalCare = useSelector(getCriticalCareSelector)
  const {
    action,
    site,
    task,
    transducerZeroedPre,
    transducerZeroedPost,
    triggerUtilizedPre,
    triggerUtilizedPost,
    IABPFrequencyPre,
    IABPFrequencyPost,
    IABPAugmentationPre,
    IABPAugmentationPost,
    slowGasLeakAlarmPre,
    slowGasLeakAlarmPost,
    timingPre,
    timingPost,
    IABPFillPre,
    IABPFillPost,
    augmentationAlarmSetPre,
    augmentationAlarmSetPost,
    leftBrachialPulsePre,
    leftBrachialPulsePost,
    distalPulsePre,
    distalPulsePost,
    extremityRestrainedPre,
    extremityRestrainedPost,
    insertionSitePulsePost,
    insertionSitePulsePre,
    inflationPointPre,
    inflationPointPost,
    deflationPointPre,
    deflationPointPost,
    diastolicAugmentationPre,
    diastolicAugmentationPost,
    unaugmentedDiastolePre,
    unaugmentedDiastolePost,
    diastolicDipPre,
    diastolicDipPost,
    augmentedSystolePre,
    augmentedSystolePost,
    unaugmentedSystolePre,
    unaugmentedSystolePost,
  } = criticalCare

  const procedure = useSelector(getProcedureStateSelector)
  const { isFirstVisit } = procedure

  const isIABPSelected = action?.name === CriticalCareConstants.IABP_MAINTENANCE
  useEffect(() => {
    if (isFirstVisit && actionOptions?.length > 0) {
      _.isEmpty(action) && dispatch(setAction(actionOptions[0]))

      if (isIABPSelected) {
        dispatch(setDefaultValuesForIABP())
      }
    }
  }, [isFirstVisit])

  const save = () => {
    dispatch(saveCriticalCare())
  }

  const actionOnChange = (option: IOption) => {
    if (option?.name === CriticalCareConstants.IABP_MAINTENANCE) {
      dispatch(setDefaultValuesForIABP())
    }
    dispatch(setAction(option))
    save()
  }

  const siteOnChange = (option: IOption) => {
    dispatch(setSite(option))
    save()
  }

  const onTaskChange = (option: IOption) => {
    dispatch(setTask(option))
    save()
  }
  const onTransducerZeroedPreChange = (option: IOption) => {
    dispatch(setTransducerZeroedPre(option))
    save()
  }
  const onTransducerZeroedPostChange = (option: IOption) => {
    dispatch(setTransducerZeroedPost(option))
    save()
  }
  const onTriggerUtilizedPreChange = (option: IOption) => {
    dispatch(setTriggerUtilizedPre(option))
    save()
  }
  const onTriggerUtilizedPostChange = (option: IOption) => {
    dispatch(setTriggerUtilizedPost(option))
    save()
  }
  const onIABPFrequencyPreChange = (option: IOption) => {
    dispatch(setIabpFrequencyPre(option))
    save()
  }
  const onIABPFrequencyPostChange = (option: IOption) => {
    dispatch(setIabpFrequencyPost(option))
    save()
  }
  const onIABPAugmentationPreChange = (option: IOption) => {
    dispatch(setIabpAugmentationPre(option))
    save()
  }
  const onIABPAugmentationPostChange = (option: IOption) => {
    dispatch(setIabpAugmentationPost(option))
    save()
  }
  const onSlowGasLeakAlarmPreChange = (option: IOption) => {
    dispatch(setSlowGasLeakAlarmPre(option))
    save()
  }
  const onSlowGasLeakAlarmPostChange = (option: IOption) => {
    dispatch(setSlowGasLeakAlarmPost(option))
    save()
  }
  const onTimingPreChange = (option: IOption) => {
    dispatch(setTimingPre(option))
    save()
  }
  const onTimingPostChange = (option: IOption) => {
    dispatch(setTimingPost(option))
    save()
  }
  const onIABPFillPreChange = (option: IOption) => {
    dispatch(setIabpFillPre(option))
    save()
  }
  const onIABPFillPostChange = (option: IOption) => {
    dispatch(setIabpFillPost(option))
    save()
  }
  const onAugmentationAlarmSetPreChange = (option: IOption) => {
    dispatch(setAugmentationAlarmSetPre(option))
    save()
  }
  const onAugmentationAlarmSetPostChange = (option: IOption) => {
    dispatch(setAugmentationAlarmSetPost(option))
    save()
  }

  const onLeftBrachialPulsePreChange = (option: IOption) => {
    dispatch(setLeftBrachialPulsePre(option))
    save()
  }
  const onLeftBrachialPulsePostChange = (option: IOption) => {
    dispatch(setLeftBrachialPulsePost(option))
    save()
  }
  const onDistalPulsePresentInAffectedExtremityPreChange = (option: IOption) => {
    dispatch(setDistalPulsePresentInAffectedExtremityPre(option))
    save()
  }
  const onDistalPulsePresentInAffectedExtremityPostChange = (option: IOption) => {
    dispatch(setDistalPulsePresentInAffectedExtremityPost(option))
    save()
  }
  const onInsertionSitePreChange = (option: IOption) => {
    dispatch(setInsertionSitePre(option))
    save()
  }
  const onInsertionSitePostChange = (option: IOption) => {
    dispatch(setInsertionSitePost(option))
    save()
  }
  const onExtremityRestrainedPreChange = (option: IOption) => {
    dispatch(setExtremityRestrainedPre(option))
    save()
  }
  const onExtremityRestrainedPostChange = (option: IOption) => {
    dispatch(setExtremityRestrainedPost(option))
    save()
  }

  const setInflationPointPreOnChange = (e: CustomEvent) => {
    dispatch(setInflationPointPre(e.detail.value))
    save()
  }

  const setInflationPointPostOnChange = (e: CustomEvent) => {
    dispatch(setInflationPointPost(e.detail.value))
    save()
  }

  const setDeflationPointPreOnChange = (e: CustomEvent) => {
    dispatch(setDeflationPointPre(e.detail.value))
    save()
  }

  const setDeflationPointPostOnChange = (e: CustomEvent) => {
    dispatch(setDeflationPointPost(e.detail.value))
    save()
  }

  const setDiastolicAugmentationPreOnChange = (e: CustomEvent) => {
    dispatch(setDiastolicAugmentationPre(e.detail.value))
    save()
  }

  const setDiastolicAugmentationPostOnChange = (e: CustomEvent) => {
    dispatch(setDiastolicAugmentationPost(e.detail.value))
    save()
  }

  const setUnaugmentedDiastolePreOnChange = (e: CustomEvent) => {
    dispatch(setUnaugmentedDiastolePre(e.detail.value))
    save()
  }

  const setUnaugmentedDiastolePostOnChange = (e: CustomEvent) => {
    dispatch(setUnaugmentedDiastolePost(e.detail.value))
    save()
  }

  const setDiastolicDipPreOnChange = (e: CustomEvent) => {
    dispatch(setDiastolicDipPre(e.detail.value))
    save()
  }

  const setDiastolicDipPostOnChange = (e: CustomEvent) => {
    dispatch(setDiastolicDipPost(e.detail.value))
    save()
  }

  const setAugmentedSystolePreOnChange = (e: CustomEvent) => {
    dispatch(setAugmentedSystolePre(e.detail.value))
    save()
  }

  const setAugmentedSystolePostOnChange = (e: CustomEvent) => {
    dispatch(setAugmentedSystolePost(e.detail.value))
    save()
  }

  const setUnaugmentedSystolePreOnChange = (e: CustomEvent) => {
    dispatch(setUnaugmentedSystolePre(e.detail.value))
    save()
  }

  const setUnaugmentedSystolePostOnChange = (e: CustomEvent) => {
    dispatch(setUnaugmentedSystolePost(e.detail.value))
    save()
  }

  return (
    <IonList id='CriticalCareContent'>
      <IonGrid className='ion-no-padding'>
        <hr className='field-divider' />
        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              label={t('criticalCare.action')}
              dataTestID='CriticalCareAction'
              options={actionOptions}
              action={actionOnChange}
              selectedOption={action}
              listHeader={t('criticalCare.action')}
              hideClearButton
            />
          </IonCol>
        </IonRow>

        <hr className='field-divider' />
        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              label={t('criticalCare.site')}
              dataTestID='Site'
              options={siteOptions}
              action={siteOnChange}
              selectedOption={site}
              listHeader={t('criticalCare.site')}
            />
          </IonCol>
        </IonRow>

        {isIABPSelected && (
          <>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onTaskChange}
                  selectedOption={task}
                  label={t('criticalCare.task')}
                  listHeader={t('criticalCare.task')}
                  dataTestID='Task'
                  options={taskOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonItemDivider color='light' className='ion-padding'>
              <IonLabel className='grid-item-divider-label' color='medium'>
                {t('criticalCare.checklist')}
              </IonLabel>
            </IonItemDivider>
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onTransducerZeroedPreChange}
                  selectedOption={transducerZeroedPre}
                  label={t('criticalCare.transducerZeroedPre')}
                  listHeader={t('criticalCare.transducerZeroedPre')}
                  dataTestID='TransducerZeroedPre'
                  options={therapeuticHypothermiaOptions}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onTransducerZeroedPostChange}
                  selectedOption={transducerZeroedPost}
                  label={t('criticalCare.transducerZeroedPost')}
                  listHeader={t('criticalCare.transducerZeroedPost')}
                  dataTestID='TransducerZeroedPost'
                  options={therapeuticHypothermiaOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onTriggerUtilizedPreChange}
                  selectedOption={triggerUtilizedPre}
                  label={t('criticalCare.triggerUtilizedPre')}
                  listHeader={t('criticalCare.triggerUtilizedPre')}
                  dataTestID='TriggerUtilizedPre'
                  options={triggerUtilizedOptions}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onTriggerUtilizedPostChange}
                  selectedOption={triggerUtilizedPost}
                  label={t('criticalCare.triggerUtilizedPost')}
                  listHeader={t('criticalCare.triggerUtilizedPost')}
                  dataTestID='TriggerUtilizedPost'
                  options={triggerUtilizedOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onIABPFrequencyPreChange}
                  selectedOption={IABPFrequencyPre}
                  label={t('criticalCare.iabpFrequencyPre')}
                  listHeader={t('criticalCare.iabpFrequencyPre')}
                  dataTestID='IABPFrequencyPre'
                  options={iabpFrequencyOptions}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onIABPFrequencyPostChange}
                  selectedOption={IABPFrequencyPost}
                  label={t('criticalCare.iabpFrequencyPost')}
                  listHeader={t('criticalCare.iabpFrequencyPost')}
                  dataTestID='IABPFrequencyPost'
                  options={iabpFrequencyOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onIABPAugmentationPreChange}
                  selectedOption={IABPAugmentationPre}
                  label={t('criticalCare.iabpAugmentationPre')}
                  listHeader={t('criticalCare.iabpAugmentationPre')}
                  dataTestID='IABPAugmentationPre'
                  options={iabpAugmentationOptions}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onIABPAugmentationPostChange}
                  selectedOption={IABPAugmentationPost}
                  label={t('criticalCare.iabpAugmentationPost')}
                  listHeader={t('criticalCare.iabpAugmentationPost')}
                  dataTestID='IABPAugmentationPost'
                  options={iabpAugmentationOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onSlowGasLeakAlarmPreChange}
                  selectedOption={slowGasLeakAlarmPre}
                  label={t('criticalCare.slowGasLeakAlarmPre')}
                  listHeader={t('criticalCare.slowGasLeakAlarmPre')}
                  dataTestID='SlowGasLeakAlarmPre'
                  options={slowGasLeakOptions}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onSlowGasLeakAlarmPostChange}
                  selectedOption={slowGasLeakAlarmPost}
                  label={t('criticalCare.slowGasLeakAlarmPost')}
                  listHeader={t('criticalCare.slowGasLeakAlarmPost')}
                  dataTestID='SlowGasLeakAlarmPost'
                  options={slowGasLeakOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onTimingPreChange}
                  selectedOption={timingPre}
                  label={t('criticalCare.timingPre')}
                  listHeader={t('criticalCare.timingPre')}
                  dataTestID='TimingPre'
                  options={autoManualOptions}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onTimingPostChange}
                  selectedOption={timingPost}
                  label={t('criticalCare.timingPost')}
                  listHeader={t('criticalCare.timingPost')}
                  dataTestID='TimingPost'
                  options={autoManualOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onIABPFillPreChange}
                  selectedOption={IABPFillPre}
                  label={t('criticalCare.iabpFillPre')}
                  listHeader={t('criticalCare.iabpFillPre')}
                  dataTestID='IABPFillPre'
                  options={autoManualOptions}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onIABPFillPostChange}
                  selectedOption={IABPFillPost}
                  label={t('criticalCare.iabpFillPost')}
                  listHeader={t('criticalCare.iabpFillPost')}
                  dataTestID='IABPFillPost'
                  options={autoManualOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setInflationPointPreOnChange}
                  label={t('criticalCare.inflationPointPre')}
                  dataTestID={'InflationPointPre'}
                  inputValue={inflationPointPre}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setInflationPointPostOnChange}
                  label={t('criticalCare.inflationPointPost')}
                  dataTestID={'InflationPointPost'}
                  inputValue={inflationPointPost}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setDeflationPointPreOnChange}
                  label={t('criticalCare.deflationPointPre')}
                  dataTestID={'DeflationPointPre'}
                  inputValue={deflationPointPre}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setDeflationPointPostOnChange}
                  label={t('criticalCare.deflationPointPost')}
                  dataTestID={'DeflationPointPost'}
                  inputValue={deflationPointPost}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onAugmentationAlarmSetPreChange}
                  selectedOption={augmentationAlarmSetPre}
                  label={t('criticalCare.augmentationAlarmSetPre')}
                  listHeader={t('criticalCare.augmentationAlarmSetPre')}
                  dataTestID='AugmentationAlarmSetPre'
                  options={therapeuticHypothermiaOptions}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onAugmentationAlarmSetPostChange}
                  selectedOption={augmentationAlarmSetPost}
                  label={t('criticalCare.augmentationAlarmSetPost')}
                  listHeader={t('criticalCare.augmentationAlarmSetPost')}
                  dataTestID='AugmentationAlarmSetPost'
                  options={therapeuticHypothermiaOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonItemDivider color='light' className='ion-padding'>
              <IonLabel className='grid-item-divider-label' color='medium'>
                {t('criticalCare.assessment')}
              </IonLabel>
            </IonItemDivider>
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onLeftBrachialPulsePreChange}
                  selectedOption={leftBrachialPulsePre}
                  label={t('criticalCare.leftBrachialPulsePre')}
                  listHeader={t('criticalCare.leftBrachialPulsePre')}
                  dataTestID='LeftBrachialPulsePre'
                  options={therapeuticHypothermiaOptions}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onLeftBrachialPulsePostChange}
                  selectedOption={leftBrachialPulsePost}
                  label={t('criticalCare.leftBrachialPulsePost')}
                  listHeader={t('criticalCare.leftBrachialPulsePost')}
                  dataTestID='LeftBrachialPulsePost'
                  options={therapeuticHypothermiaOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onDistalPulsePresentInAffectedExtremityPreChange}
                  selectedOption={distalPulsePre}
                  label={t('criticalCare.distalPulsePresentInAffectedExtremityPre')}
                  listHeader={t('criticalCare.distalPulsePresentInAffectedExtremityPre')}
                  dataTestID='DistalpulsepresentinAffectedExtremityPre'
                  options={therapeuticHypothermiaOptions}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onDistalPulsePresentInAffectedExtremityPostChange}
                  selectedOption={distalPulsePost}
                  label={t('criticalCare.distalPulsePresentInAffectedExtremityPost')}
                  listHeader={t('criticalCare.distalPulsePresentInAffectedExtremityPost')}
                  dataTestID='DistalpulsepresentinAffectedExtremityPost'
                  options={therapeuticHypothermiaOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onInsertionSitePreChange}
                  selectedOption={insertionSitePulsePre}
                  label={t('criticalCare.insertionSitePre')}
                  listHeader={t('criticalCare.insertionSitePre')}
                  dataTestID='InsertionSitePre'
                  options={insertionSiteOptions}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onInsertionSitePostChange}
                  selectedOption={insertionSitePulsePost}
                  label={t('criticalCare.insertionSitePost')}
                  listHeader={t('criticalCare.insertionSitePost')}
                  dataTestID='InsertionSitePost'
                  options={insertionSiteOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onExtremityRestrainedPreChange}
                  selectedOption={extremityRestrainedPre}
                  label={t('criticalCare.extremityRestrainedPre')}
                  listHeader={t('criticalCare.extremityRestrainedPre')}
                  dataTestID='ExtremityRestrainedPre'
                  options={therapeuticHypothermiaOptions}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SingleSelect
                  action={onExtremityRestrainedPostChange}
                  selectedOption={extremityRestrainedPost}
                  label={t('criticalCare.extremityRestrainedPost')}
                  listHeader={t('criticalCare.extremityRestrainedPost')}
                  dataTestID='ExtremityRestrainedPost'
                  options={therapeuticHypothermiaOptions}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setDiastolicAugmentationPreOnChange}
                  label={t('criticalCare.diastolicAugmentationPre')}
                  dataTestID={'DiastolicAugmentationPre'}
                  inputValue={diastolicAugmentationPre}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setDiastolicAugmentationPostOnChange}
                  label={t('criticalCare.diastolicAugmentationPost')}
                  dataTestID={'DiastolicAugmentationPost'}
                  inputValue={diastolicAugmentationPost}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setUnaugmentedDiastolePreOnChange}
                  label={t('criticalCare.unaugmentedDiastolePre')}
                  dataTestID={'UnaugmentedDiastolePre'}
                  inputValue={unaugmentedDiastolePre}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setUnaugmentedDiastolePostOnChange}
                  label={t('criticalCare.unaugmentedDiastolePost')}
                  dataTestID={'UnaugmentedDiastolePost'}
                  inputValue={unaugmentedDiastolePost}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setDiastolicDipPreOnChange}
                  label={t('criticalCare.diastolicDipPre')}
                  dataTestID={'DiastolicDipPre'}
                  inputValue={diastolicDipPre}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setDiastolicDipPostOnChange}
                  label={t('criticalCare.diastolicDipPost')}
                  dataTestID={'DiastolicDipPost'}
                  inputValue={diastolicDipPost}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setAugmentedSystolePreOnChange}
                  label={t('criticalCare.augmentedSystolePre')}
                  dataTestID={'AugmentedSystolePre'}
                  inputValue={augmentedSystolePre}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setAugmentedSystolePostOnChange}
                  label={t('criticalCare.augmentedSystolePost')}
                  dataTestID={'AugmentedSystolePost'}
                  inputValue={augmentedSystolePost}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setUnaugmentedSystolePreOnChange}
                  label={t('criticalCare.unaugmentedSystolePre')}
                  dataTestID={'UnaugmentedSystolePre'}
                  inputValue={unaugmentedSystolePre}
                />
              </IonCol>
              <IonCol className='picklist'>
                <SInput
                  onChangeAction={setUnaugmentedSystolePostOnChange}
                  label={t('criticalCare.unaugmentedSystolePost')}
                  dataTestID={'UnaugmentedSystolePost'}
                  inputValue={unaugmentedSystolePost}
                />
              </IonCol>
            </IonRow>
          </>
        )}
      </IonGrid>
      <IonItemDivider color='light' />
    </IonList>
  )
}

export default CriticalCareContent
